import * as React from "react";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { TableHead } from "./table";

interface SortableTableHeadProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
  onSort?: () => void;
  sortDirection?: 'asc' | 'desc' | null;
  sortable?: boolean;
  children: React.ReactNode;
}

export const SortableTableHead = React.forwardRef<
  HTMLTableCellElement,
  SortableTableHeadProps
>(({ onSort, sortDirection, sortable = true, children, className, ...props }, ref) => {
  if (!sortable) {
    return (
      <TableHead ref={ref} className={className} {...props}>
        {children}
      </TableHead>
    );
  }

  return (
    <TableHead
      ref={ref}
      className={cn(
        "cursor-pointer select-none hover:bg-muted/50 transition-colors",
        className
      )}
      onClick={onSort}
      {...props}
    >
      <div className="flex items-center gap-2">
        <span>{children}</span>
        {sortDirection === 'asc' && <ArrowUp className="h-4 w-4" />}
        {sortDirection === 'desc' && <ArrowDown className="h-4 w-4" />}
        {sortDirection === null && <ArrowUpDown className="h-4 w-4 text-muted-foreground opacity-50" />}
      </div>
    </TableHead>
  );
});

SortableTableHead.displayName = "SortableTableHead";
